module.exports = "/img/comment-summary.acdbae04.png";